import styled from 'styled-components'

export const CountryPageContainer = styled.div`

width:100%;
height:100vh
`